module.exports = __webpack_public_path__ + "r-v3/img/screen_increase.d66688df.svg";